import { render, staticRenderFns } from "./roleClearRequest.vue?vue&type=template&id=0060b070&"
import script from "./roleClearRequest.vue?vue&type=script&lang=js&"
export * from "./roleClearRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0060b070')) {
      api.createRecord('0060b070', component.options)
    } else {
      api.reload('0060b070', component.options)
    }
    module.hot.accept("./roleClearRequest.vue?vue&type=template&id=0060b070&", function () {
      api.rerender('0060b070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/roleClearRequest.vue"
export default component.exports